import React from 'react';
import './MediaPage.css';

class MediaPage extends React.Component {
  render() {
    return (
      <div>
        <input type="file"></input>
      </div>
    )
  }
}

export default MediaPage;